import React, {
  useEffect,
  useState,
} from 'react';
import {
  Outlet,
} from 'react-router-dom';
import isNil from 'lodash/isNil';
import Navigation from 'pages/Dashboard/pages/Billing/Navigation';
import {
  claimEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import {
  Claim,
} from 'pages/Dashboard/pages/Billing/types';
import ClaimSplitDialog from 'pages/Dashboard/pages/Billing/ClaimForm/ClaimSplitDialog';
import ClaimActivityDialog, {
  ClaimActivityDialogParams,
} from 'pages/Dashboard/pages/Billing/ClaimForm/ClaimActivity/ClaimActivityDialog';
import SecondaryClaimDialog, {
  SecondaryClaimDialogParams,
} from 'pages/Dashboard/pages/Billing/ClaimForm/SecondaryClaimDialog';

export default function Billing() {
  const [claimSplitDialogParams, setClaimSplitDialogParams] = useState<
    Claim | null>(null);
  const [secondaryClaimDialogParams, setSecondaryClaimDialogParams] = useState<
    SecondaryClaimDialogParams | null>(null);
  const [claimActivityDialogParams, setClaimActivityDialogParams] = useState<
    ClaimActivityDialogParams | null>(null);

  useEffect(() => {
    const unsubscribeFromSplit = claimEventChannel.on('onClaimSplitOpen', (claim: Claim) => {
      setClaimSplitDialogParams(claim);
    });

    const unsubscribeFromSecondary = claimEventChannel.on('onSecondaryClaimCreateOpen', (params) => {
      setSecondaryClaimDialogParams(params);
    });

    const unsubscribeFromActivity = claimEventChannel.on('onClaimActivityOpen', ({ claimId }) => {
      setClaimActivityDialogParams({ claimId });
    });

    return () => {
      unsubscribeFromSplit();
      unsubscribeFromSecondary();
      unsubscribeFromActivity();
    };
  }, []);

  return (
    <div className="flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden">
      <Navigation />
      <div className="flex min-h-0 min-w-0 flex-1 overflow-hidden pt-4">
        <Outlet />
        {!isNil(claimSplitDialogParams) && (
          <ClaimSplitDialog
            claim={claimSplitDialogParams}
            onClose={() => { setClaimSplitDialogParams(null); }}
          />
        )}
        {!isNil(secondaryClaimDialogParams) && (
          <SecondaryClaimDialog
            {...secondaryClaimDialogParams}
            onClose={() => { setSecondaryClaimDialogParams(null); }}
          />
        )}
        {!isNil(claimActivityDialogParams) && (
          <ClaimActivityDialog
            {...claimActivityDialogParams}
            onClose={() => { setClaimActivityDialogParams(null); }}
          />
        )}
      </div>
    </div>
  );
}
